export default __webpack_public_path__ + "static/media/BIPLS.4b17f2e1.png";